import { ImoShipTypeEnum } from 'src/enums/stowage/imoShipTypeEnum';
import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const tankVolumeCapacityExceededForCargoIbcShipTypeTwoHardRule: StowageRuleBM = {
    id: StowageRuleId.TankVolumeCapacityExceededForCargoIbcShipTypeTwoHardRule,
    name: 'The maximum stowed volume of a type 2 cargo in a tank cannot exceed 3000 m3.',
    lastUpdatedUtc: '2024-07-26T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Cargo property product.category.shipType',
                            fieldPath: 'cargo.product.category.shipType',
                            type: 'number',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'Reference value',
                            type: 'number',
                            referenceValue: ImoShipTypeEnum.Two.toString(),
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.Equals,
                },
            },
            {
                leaf: {
                    properties: [
                        {
                            name: 'Tank content volume',
                            fieldPath: 'getTankContentVolume',
                            type: 'number',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'Reference value',
                            type: 'number',
                            referenceValue: '3000',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.IsGreaterThan,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.HardRule,
        parameter: 'Tank volume capacity exceeded for cargo with IBC ship type 2',
    },
};
